export default __webpack_public_path__ + "media/zurb/fonts/ProximaNova-Regular-cfadbd8053ac1b10be9a7fd6ce5baa77.woff2";